import axios from "axios";
import store from "@/state/store";
import { validateExpireAccessToken } from "@/helpers/utils/jwt";
import { eventBus } from '@/main.js'
import Vue from 'vue'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    "Content-Type": "application/json",
  },
});

request.interceptors.request.use(
  async (request) => {
    if (!store.getters["auth/getIsAuthenticated"]) {
       redirectLogin()
    } else {
      const accessToken = store.getters["auth/getAccessToken"];
      if (await validateExpireAccessToken(accessToken)) {
        request.headers.Authorization = "Bearer " + accessToken;
      } else {
        redirectLogin()
      }
    }

    return request;
  },
  (error) => {
    eventBus.$emit('changeLoadingState', false)
    eventBus.$emit('internalServerError', error.response)
    return Promise.reject(error);
  }
);


request.interceptors.response.use(
  response => {
    eventBus.$emit('changeLoadingState', false)
    return response
  },
  error => {
    eventBus.$emit('changeLoadingState', false)
    if (error.response) {
      switch (error.response.status) {
        case 400:
          break
        case 401:
          redirectLogin()
        case 403:
          break
        case 404:
          // window.location = "/404";
          // if (error.response.data && error.response.data.message) {
          //   error.response.data.message = error.response.data.message.replace(
          //     '{"message":"',
          //     ''
          //   )
          //   error.response.data.message = error.response.data.message.replace(
          //     '"}',
          //     ''
          //   )
          // }else {
          //   error.response.data.message = "ไม่พบข้อมูล"
          // }

          break
        case 409:
          if (error.response.data && error.response.data.message) {
            error.response.data.message = error.response.data.message.replace(
              '{"message":"',
              ''
            )
            error.response.data.message = error.response.data.message.replace(
              '"}',
              ''
            )
          }else {
            error.response.data.message = "ข้อมูลซ้ำหรือมีอยู่แล้ว"
          }
          break
        case 412:
          if (error.response.data && error.response.data.message) {
            error.response.data.message = error.response.data.message.replace(
              '{"message":"',
              ''
            )
            error.response.data.message = error.response.data.message.replace(
              '"}',
              ''
            )
          }
          break
        case 500:
          eventBus.$emit('internalServerError', error.response)
          break
        default:
          console.log('Error')
      }
    }
    return error
  }
)

// request.interceptors.response.use(
//   (response) => {

//     return response;
//   },
//   (error) => {
//     if (error.response) {
//       switch (error.response.status) {
//         case 400:
//           return error
//         case 401:
//             redirectLogin()
//         case 403:
//           break;
//         case 404:
//           return error
//         case 409:
//           break;
//         case 412:
//           break;
//         case 500:
//           EventBus.$emit('internalServerError', error.response)
//           break;
//         default:
//           console.log("Error");
//       }
//     }
//     return Promise.reject(error);
//   }
// );

const redirectLogin = () => {
  store.dispatch("auth/removeAllAuthen");
  window.location = "/login";
    // window.location.href = `${process.env.VUE_APP_BASE_API_AUTHEN}/authentication?applicationcode=PIM&callback=${process.env.VUE_APP_BASE_MY_URL}/portal&redirecturl=/`
}

const core = {
  head(endpoint, data, config) {
    const params = {
      params: data
    };
    const newParams = Object.assign(params, config);
    return request.head(endpoint, newParams);
  },
  headRoute(endpoint) {
    return request.head(endpoint);
  },
  fetch(endpoint, data, config) {
    const params = {
      params: data
    };
    const newParams = Object.assign(params, config);
    return request.get(endpoint, newParams);
  },

  create(endpoint, data, config) {
    return request.post(endpoint, data, config);
  },
    upload(endpoint, data) {
    const accessToken = Vue.$cookies.get('.at')
    return axios({
      method: 'post',
      processData: false,
      contentType: 'multipart/form-data',
      cache: false,
      url: endpoint,
      data: data,
      headers: {
        Authorization: 'Bearer ' + accessToken,
      },
    })
  },
  update(endpoint, data, config) {
    return request.put(endpoint, data, config);
  },
  patch(endpoint, data, config) {
    return request.patch(endpoint, data, config);
  },
  edit(endpoint, data, config) {
    return request.patch(endpoint, data, config);
  },
  remove(endpoint, data, config) {
    const params = { data };
    const newParams = Object.assign(params, config);
    return request.delete(endpoint, newParams);
  },
  delete(endpoint, id, config) {
    const params = {
      params: {
        id
      }
    };
    const newParams = Object.assign(params, config);
    return request.delete(endpoint, newParams);
  }
}

export default core;
